module.exports = __webpack_public_path__ + "img/bannerBlue.96427041.jpg";